var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdealInventory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#00CEB5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.082 20.3307H16.9987C17.4407 20.3307 17.8646 20.1551 18.1772 19.8426C18.4898 19.53 18.6654 19.1061 18.6654 18.6641V8.66407C18.666 8.39999 18.6144 8.1384 18.5134 7.8944C18.4124 7.65039 18.2641 7.4288 18.077 7.2424L15.087 4.2524C14.9006 4.06534 14.679 3.91703 14.435 3.81606C14.191 3.71508 13.9294 3.66342 13.6654 3.66407H6.9987C6.55667 3.66407 6.13275 3.83966 5.82019 4.15222C5.50763 4.46478 5.33203 4.88871 5.33203 5.33074V8.4974",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.668 3.66406V7.83073C13.668 8.05174 13.7558 8.2637 13.912 8.41998C14.0683 8.57626 14.2803 8.66406 14.5013 8.66406H18.668",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7513 13.8359L7.83464 16.1693L3.91797 13.8359",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50137 12.9145C4.2447 13.0628 4.03225 13.2769 3.88592 13.5347C3.73958 13.7925 3.66465 14.0847 3.66887 14.3811V17.0811C3.65913 17.3779 3.72885 17.6719 3.87082 17.9326C4.01278 18.1934 4.22184 18.4116 4.47637 18.5645L7.00137 20.0811C7.25694 20.2334 7.54859 20.3144 7.84606 20.3159C8.14353 20.3173 8.43597 20.2392 8.69303 20.0895L11.168 18.5811C11.4248 18.4329 11.6375 18.2188 11.784 17.961C11.9304 17.7032 12.0055 17.411 12.0014 17.1145V14.4145C12.011 14.1176 11.9412 13.8236 11.7991 13.5628C11.6569 13.302 11.4477 13.0839 11.193 12.9311L8.66803 11.4145C8.41246 11.2622 8.1208 11.1812 7.82333 11.1797C7.52586 11.1782 7.23342 11.2564 6.97636 11.4061L4.50137 12.9145Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83203 16.1641V20.3307",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdealInventory);
export default __webpack_public_path__ + "static/media/ideal_inventory.4f0be976666785c520de881e977101ed.svg";
export { ForwardRef as ReactComponent };